// PDF batch export - S48.2b.
// PDF multipagina sin libs: por cada producto valido genera un PNG dataUrl
// y construye un HTML con N <div class='page'> que el navegador imprime.
// 1 etiqueta por pagina. Auto window.print() al cargar.
import { findSize } from '../utils';
import { renderEtiquetaPng } from './png_export';
import { generarCamposTecnicosConAutoLayout } from '../autolayout';

function _safeName(s) {
  return String(s || '').replace(/[^A-Za-z0-9_-]+/g, '-').replace(/^-+|-+$/g, '');
}

function _escHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function _buildHtml(images, sz, title) {
  const wMm = sz.wMm.toFixed(2);
  const hMm = sz.hMm.toFixed(2);
  const t = _escHtml(title || 'Factura');
  const pages = [];
  for (let i = 0; i < images.length; i += 1) {
    pages.push('<div class="page"><img alt="' + (i + 1) + '" src="' + images[i] + '" /></div>');
  }
  return [
    '<!doctype html>',
    '<html lang="es">',
    '<head>',
    '<meta charset="utf-8">',
    '<title>' + t + '</title>',
    '<style>',
    '@page { size: ' + wMm + 'mm ' + hMm + 'mm; margin: 0; }',
    'html, body { margin: 0; padding: 0; background: #fff; }',
    '.page { width: ' + wMm + 'mm; height: ' + hMm + 'mm; box-sizing: border-box; page-break-after: always; }',
    '.page:last-child { page-break-after: auto; }',
    '.page img { display: block; width: 100%; height: 100%; }',
    '.no-print { position: fixed; top: 12px; right: 12px; }',
    '.no-print button { padding: 8px 14px; font: 500 13px sans-serif; cursor: pointer; }',
    '@media print { .no-print { display: none; } }',
    '</style>',
    '</head>',
    '<body>',
    pages.join('\n'),
    '<div class="no-print">',
    '<button onclick="window.print()">Imprimir / Guardar PDF</button>',
    '</div>',
    '<script>window.addEventListener("load", function () { setTimeout(function () { window.print(); }, 250); });</script>',
    '</body>',
    '</html>',
  ].join('\n');
}

export function exportEtiquetaPdfBatch(productosValidos, factura, layoutBase, sizeId, logosConfig) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;
  if (!Array.isArray(productosValidos) || productosValidos.length === 0) return false;
  if (!Array.isArray(layoutBase) || layoutBase.length === 0) return false;
  const sz = findSize(sizeId);
  const urls = [];
  for (let i = 0; i < productosValidos.length; i += 1) {
    const producto = productosValidos[i];
    if (!producto) continue;
    const fields = generarCamposTecnicosConAutoLayout(producto, layoutBase, logosConfig);
    const state = { sizeId: sizeId, fields: fields };
    const dataUrl = renderEtiquetaPng(state, producto, null);
    if (dataUrl) urls.push(dataUrl);
  }
  if (urls.length === 0) return false;
  const fid = factura && (factura.id != null) ? factura.id : 'sin-id';
  const title = 'factura_' + _safeName(String(fid));
  const html = _buildHtml(urls, sz, title);
  const w = window.open('', '_blank');
  if (!w) return false;
  w.document.open();
  w.document.write(html);
  w.document.close();
  return true;
}
